import { render, staticRenderFns } from "./CustomHeadline.vue?vue&type=template&id=6f45774b&scoped=true&"
import script from "./CustomHeadline.vue?vue&type=script&lang=js&"
export * from "./CustomHeadline.vue?vue&type=script&lang=js&"
import style0 from "./CustomHeadline.vue?vue&type=style&index=0&id=6f45774b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f45774b",
  null
  
)

export default component.exports